import { List, ListItem } from "@mui/material";

import EChartToolTip from "./EChartToolTip";
import { ToolTipLegendCircle } from "./ToolTipLegendCircle";

interface RelianceChartToolTipProps {
  seriesData: {
    name: string;
    color: string;
    borderColor: string;
    seriesName: string;
    value: string;
    percentage: string;
  }[];
  totalSales: string;
}

export const RelianceChartToolTip: React.FC<RelianceChartToolTipProps> = ({
  seriesData,
  totalSales,
}) => {
  return (
    <EChartToolTip>
      <List>
        <ListItem> {seriesData[0]?.name}</ListItem>
        {seriesData.map(
          (item, index) =>
            item.value != "NA" && (
              <ListItem key={index}>
                <ToolTipLegendCircle color={item.color} border={item.borderColor} />
                {item.seriesName}: {item.value} ({item.percentage})
              </ListItem>
            )
        )}
        <ListItem> Total Sales: {totalSales}</ListItem>
      </List>
    </EChartToolTip>
  );
};
